module.exports = __webpack_public_path__ + "img/photo-studio-razor-15.0f2f2103.png";